import { ACTION_TYPES } from 'src/constants';
import { INITIAL_STATE } from '../store';

export default function TaxStatuReducer(state = INITIAL_STATE.taxStatuses, action) {
  switch (action.type) {
    case ACTION_TYPES.REQUEST_TAX_STATUS:
      return state;

    case ACTION_TYPES.REQUEST_TAX_STATUS_SUCCEEDED:
      return [...action.payload];

    case ACTION_TYPES.REQUEST_TAX_STATUS_FAILED:
      return state;

    case ACTION_TYPES.REQUEST_LOGOUT_SUCCEEDED: {
      return INITIAL_STATE.taxStatuses;
    }

    default:
      return state;
  }
}
